"use client";
import React from "react";
import { NewsletterSections as NewsletterSectionsUI } from "@org/ui";
import { useTranslations } from "@/lib/config/useTranslations";
import { useLanguage } from "@/lib/config/useLanguage";
import { translations as staticTranslations } from "@/lib/config/translations";

export default function NewsletterSections() {
  const translations = useTranslations();
  const { langCode, localizePath } = useLanguage();

  // Используем статические переводы как fallback, если newsletter отсутствует
  const newsletter = translations.newsletter || staticTranslations[langCode]?.newsletter || staticTranslations.ru.newsletter;

  const newsletterTranslations = {
    placeholder: newsletter.placeholder,
    buttonSubmit: newsletter.buttonSubmit,
    buttonSubmitting: newsletter.buttonSubmitting,
    title: newsletter.title,
    privacyText: newsletter.privacyText,
    privacyLink: newsletter.privacyLink,
    successMessage: newsletter.successMessage,
    errorMessage: newsletter.errorMessage,
  };

  const privacyPolicyUrl = localizePath('/legal/politika-konfidentsialnosti');

  return (
    <NewsletterSectionsUI
      title={newsletter.title}
      translations={newsletterTranslations}
      privacyPolicyUrl={privacyPolicyUrl}
      locale={langCode}
    />
  );
}